module.exports = __webpack_public_path__ + "assets/img/driver-btn-049e6437.png";